import { PROJECT_STATUS, TARGET_ACTIONS } from '@nexxt/common/types';
import {
    PROJECT_TEMPLATE_CODES,
    RAPID_SOLUTION_IDS
} from '@nexxt/common/constants';
import {
    ALERT_MESSAGE_TYPES,
    PROJECT_EDIT_MODES
} from '../interface/project.interface';
import { questionWarningMessage } from './alertMessage';
import { RBC_VIDEO_TEMPLATE_QUESTION_TEXTS } from './defaultText';
import { rapidSolutionOrder } from '../mapping/project';

export const PROJECT_BASE_COST = 1000;
export const SANDBOX_PROJECT = {
    status: PROJECT_STATUS.LIVE,
    id: 931,
    codeName: '931',
    name: 'Demo Study',
    lastModifiedOn: new Date().toJSON()
};

export interface PortalSession {
    viewed: boolean;
    featuredRapidSolution: string;
    seenRapidSolutions: RapidSolutions;
    lastLoggedIn: string;
    lastSidebarExpanded: boolean;
}
export interface RapidSolutions {
    [RAPID_SOLUTION_IDS.RAPID_VIDEO_AD_TEST]: boolean;
    [RAPID_SOLUTION_IDS.RAPID_COPY_TEST]: boolean;
    [RAPID_SOLUTION_IDS.RAPID_IMAGE_TEST]: boolean;
}

export const INITIAL_SESSION: PortalSession = {
    viewed: false,
    featuredRapidSolution: rapidSolutionOrder[rapidSolutionOrder.length - 1],
    seenRapidSolutions: {
        [RAPID_SOLUTION_IDS.RAPID_VIDEO_AD_TEST]: false,
        [RAPID_SOLUTION_IDS.RAPID_COPY_TEST]: false,
        [RAPID_SOLUTION_IDS.RAPID_IMAGE_TEST]: false
    },
    lastLoggedIn: null,
    lastSidebarExpanded: true
};

export const LOCK_PROJECT = {
    TEMPLATE_MODE: {
        [PROJECT_TEMPLATE_CODES.RBC_VIDEO_TEST]: {
            project: ['projectName', 'codeName', 'client', 'disqualification'],
            audience: ['all', { title: 'loi', enabled: true }],
            questions: [
                {
                    title: 'show ad',
                    showDropdown: true,
                    predefinedList: RBC_VIDEO_TEMPLATE_QUESTION_TEXTS,
                    showMedia: false,
                    videoOnly: true,
                    alertMessages: [
                        {
                            type: ALERT_MESSAGE_TYPES.WARN,
                            message:
                                questionWarningMessage.RBC_VIDEO_TEMPLATE_DISABLE_WARNING_1
                        },
                        {
                            type: ALERT_MESSAGE_TYPES.DANGER,
                            message:
                                questionWarningMessage.RBC_VIDEO_TEMPLATE_DISABLE_WARNING_2
                        }
                    ]
                },
                {
                    title: 'In-video annotation',
                    videoOnly: true,
                    alertMessages: [
                        {
                            type: ALERT_MESSAGE_TYPES.WARN,
                            message:
                                questionWarningMessage.RBC_VIDEO_TEMPLATE_DISABLE_WARNING_1
                        },
                        {
                            type: ALERT_MESSAGE_TYPES.DANGER,
                            message:
                                questionWarningMessage.RBC_VIDEO_TEMPLATE_DISABLE_WARNING_2
                        }
                    ]
                }
            ],
            preview: []
        },
        [PROJECT_TEMPLATE_CODES.RBC_COPY_TEST]: {
            project: ['projectName', 'codeName', 'client', 'disqualification'],
            audience: ['all', { title: 'loi', enabled: false }],
            questions: [
                {
                    title: 'show ad',
                    showMedia: true,
                    alertMessages: [
                        {
                            type: ALERT_MESSAGE_TYPES.WARN,
                            message:
                                questionWarningMessage.RBC_COPY_TEMPLATE_DISABLE_WARNING_1
                        }
                    ]
                },
                {
                    title: 'detailed feedback',
                    alertMessages: [
                        {
                            type: ALERT_MESSAGE_TYPES.WARN,
                            message:
                                questionWarningMessage.RBC_COPY_TEMPLATE_DISABLE_WARNING_2
                        }
                    ] /**@TODO wording should be modified */
                }
            ],
            preview: []
        }
    }
};

export const TEMPLATE_VIDEO_ONLY_BUBBLES = [
    { subtext: 'Must be', text: '.mp4' },
    { subtext: 'Less than', text: '1min' },
    { subtext: 'Up to', text: '200MB' }
];

export const DISABLED_EDIT_MODES = [
    PROJECT_EDIT_MODES.DISABLED,
    PROJECT_EDIT_MODES.REPUBLISH
];

export const TARGET_ACTIONS_ITEMS = [
    { label: 'Avoid', value: TARGET_ACTIONS.AVOID },
    {
        label: 'Trigger if detected',
        value: TARGET_ACTIONS.TRIGGER_ON_DETECTION
    },
    {
        label: 'Trigger if NOT detected',
        value: TARGET_ACTIONS.TRIGGER_ON_ABSENCE
    },
    { label: 'Trigger always', value: TARGET_ACTIONS.TRIGGER_ALWAYS },
    {
        label: 'End conversation if detected',
        value: TARGET_ACTIONS.TERMINATE_ON_DETECTION
    },
    { label: 'None', value: TARGET_ACTIONS.NONE }
];

export const TARGET_DETECTION_TYPES = [
    { label: 'Default', value: false },
    { label: 'Custom', value: true }
];
